import { notification } from 'antd';
import moment from 'moment';

import apiShipper from '../../../services/apiShipper';
import { RANGER_DEFAULT_DATE, SORTER_DEFAULT_PARAMS } from '../constants';

export async function viagemReportService({ clientes, filter, pagination }) {
  try {
    const sorter = SORTER_DEFAULT_PARAMS;

    if (filter.sorter && filter.sorter.order) {
      const { field, order } = filter.sorter;
      const orderLength = order === 'ascend' ? 3 : 4;

      sorter.metodo_ordenacao = order.substr(0, orderLength).toUpperCase();
      sorter.ordenar_pela_coluna = field;
    }

    delete filter.sorter;

    const { days, unity } = RANGER_DEFAULT_DATE;

    const period = {
      inicio_periodo: moment()
        .subtract(days, unity)
        .subtract()
        .unix(),
      final_periodo: moment().unix(),
    };

    const response = await apiShipper.post('buscar-ftviagem', {
      cpf_cnpj_cliente_pagador: clientes.map(cliente => cliente.cnpj),
      page: pagination.current || 1,
      take: pagination.pageSize || 10,
      ...period,
      ...sorter,
      ...filter,
    });

    return { ...response.data };
  } catch {
    notification.error({
      message: 'Ops, não conseguimos buscar as viagens.',
      description:
        'Caso o problema persista, entre em contato com nosso suporte.',
    });
  }
}
